import {
  basicActionListener,
  bulkOfferCustomizedActionListener,
  businessBankDetailsActionListener,
  campaignContentActionListener,
  campaignsActionWithLabelListener,
  changeSortingOfReportingForInstagramPostsUserActionListener,
  changeSortingOfReportingForInstagramStoriesOrReelsActionListener,
  changeSortingOfReportingForTikTokVideosActionListener,
  choseActionForBulkOfferUpdateUserActionListener,
  collectionStatsViewedActionListener,
  collectionTabSelectedActionListener,
  creatorCollectionDownloadActionListener,
  deliverableUploadedActionActionListener,
  discoveryFiltersActionListener,
  downloadExcelReportV2UserActionListener,
  likeAudienceDataActionListener,
  profileActionWithLabelListener,
  showStatDetailsForOfContentCardUserActionListener,
  sovActionListener,
  userDropdownNavigationFinishedUserActionListener
} from '../utils/user-action-listeners';

import {
  UserAction,
  UserActionListener
} from '../types/user-actions';

// please sort alphabetically
const USER_ACTION_LISTENERS: ReadonlyArray<UserActionListener> = [
  basicActionListener,
  bulkOfferCustomizedActionListener,
  campaignContentActionListener,
  campaignsActionWithLabelListener,
  changeSortingOfReportingForInstagramPostsUserActionListener,
  changeSortingOfReportingForInstagramStoriesOrReelsActionListener,
  changeSortingOfReportingForTikTokVideosActionListener,
  choseActionForBulkOfferUpdateUserActionListener,
  collectionStatsViewedActionListener,
  collectionTabSelectedActionListener,
  creatorCollectionDownloadActionListener,
  deliverableUploadedActionActionListener,
  discoveryFiltersActionListener,
  downloadExcelReportV2UserActionListener,
  likeAudienceDataActionListener,
  profileActionWithLabelListener,
  showStatDetailsForOfContentCardUserActionListener,
  sovActionListener,
  businessBankDetailsActionListener,
  userDropdownNavigationFinishedUserActionListener
];

interface UserActionProviderState {
  userActions: Array<UserAction>,
  readonly userActionListeners: ReadonlyArray<UserActionListener>
}

const state: UserActionProviderState = {
  userActions: [],
  userActionListeners: USER_ACTION_LISTENERS
};

const handleUserActions = (): void => {
  state.userActions = state.userActionListeners.reduce(
    (actions, listener) => {
      if (actions.length === 0) {
        return actions;
      }

      return listener(actions);
    },
    state.userActions
  );

  // Avoid cases when it's huge list of unhandled events.
  if (state.userActions.length > 100) {
    state.userActions = state.userActions.slice(-25);
  }
};

export const addUserAction = (action: UserAction): void => {
  state.userActions.push(action);
  handleUserActions();
};
